import AsyncStorage from '@react-native-async-storage/async-storage';

export const PENDING_PAYMENT_KEY = '@baratao/pending_payment';
export const NAV_STATE_KEY = '@baratao/nav_state';
export const BG_TIME_KEY = '@baratao/last_bg_time';

export const PAYMENT_SCREENS = ['Payment', 'PaymentNovo', 'PP_Checkout'];

const PENDING_PAYMENT_TTL_MS = 2 * 60 * 1000;

export type PendingPayment = {
  screen: string;
  state: any;
  savedAt: number;
};

export function getActiveRouteName(state: any): string | null {
  if (!state?.routes?.length) {return null;}
  const route = state.routes[state.index ?? state.routes.length - 1];
  if (route.state) {return getActiveRouteName(route.state);}
  return route.name ?? null;
}

export function getActiveRouteParams(state: any): any {
  if (!state?.routes?.length) {return null;}
  const route = state.routes[state.index ?? state.routes.length - 1];
  if (route.state) {return getActiveRouteParams(route.state);}
  return route.params ?? null;
}

export async function savePendingPaymentIfNeeded(raw: string): Promise<void> {

  try {
    const parsed = JSON.parse(raw);
    const activeScreen = getActiveRouteName(parsed);
    if (activeScreen && PAYMENT_SCREENS.includes(activeScreen)) {
      await AsyncStorage.setItem(
        PENDING_PAYMENT_KEY,
        JSON.stringify({screen: activeScreen, state: parsed, savedAt: Date.now()} satisfies PendingPayment),
      );
    }
  } catch {}
}

export async function clearPendingPayment(): Promise<void> {
  await AsyncStorage.removeItem(PENDING_PAYMENT_KEY);
}

export async function consumePendingPayment(): Promise<PendingPayment | null> {
  const raw = await AsyncStorage.getItem(PENDING_PAYMENT_KEY);
  await AsyncStorage.removeItem(PENDING_PAYMENT_KEY);
  if (!raw) {return null;}
  try {
    const pending = JSON.parse(raw) as PendingPayment;
    if (Date.now() - pending.savedAt > PENDING_PAYMENT_TTL_MS) {return null;}
    return pending;
  } catch {
    return null;
  }
}
